export function checkClassesOnBody(cssClassList: string[]): boolean {
    return cssClassList.some(className => document.body.classList.contains(className));
}